import { ViewScopeService } from '../../../services/view-scope.service';
import { Injectable } from '@angular/core';
import { INDEX_SECTIONS_DEFINERS, INDEX_SECTIONS_DEFINITIONS, INDEX_SECTIONS_SUBMIT } from '../../../services/account-api.constants';
import { AjaxService } from '../../../services/ajax.service';

export interface UploadedFileInfo {
	id: string;
	file: File;
	status: string;
	disp_status: string;
}

@Injectable({ providedIn: 'root' })
export class IndexInsertService {
	constructor(private viewScopeService: ViewScopeService, private ajaxService: AjaxService) { }

	// Timeline state
	private _timelineStep = 1;
	private _stepTables: any[][] = [[], []]; // 0: Match Sections, 1: Save/Finish (if needed)
	private _saveMessage = '';

	// Single uploader for up to 3 .xlsx files
	private _uploadedFileInfo: UploadedFileInfo[] = [];

	get timelineStep(): number {
		return this._timelineStep;
	}
	set timelineStep(val: number) {
		this._timelineStep = val;
		this.saveState();
	}

	get uploadedFileInfo(): UploadedFileInfo[] {
		return this._uploadedFileInfo;
	}

	get stepTables(): any[][] {
		return this._stepTables;
	}

	get saveMessage(): string {
		return this._saveMessage;
	}

	clearFiles() {
		this._uploadedFileInfo = [];
	}

	addFiles(files: File[]): boolean {
		// Only allow up to 3 .xlsx files in total
		const validFiles = files.filter(f => this.isXlsx(f));
		if (validFiles.length === 0) {
			return false;
		}
		// Filter out files that are already in the list (by name and size)
		const newFiles = validFiles.filter(f =>
			!this._uploadedFileInfo.some(existing =>
				existing.file.name === f.name && existing.file.size === f.size
			)
		);
		// Enforce the 3-file limit
		const totalFiles = this._uploadedFileInfo.length + newFiles.length;
		if (totalFiles > 3) {
			return false;
		}
		this._uploadedFileInfo = [
			...this._uploadedFileInfo,
			...newFiles.map(file => ({
				id: `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
				file: file,
				status: 'Pending',
				disp_status: 'Pending'
			}))
		];
		return true;
	}

	markAllUploaded() {
		this._uploadedFileInfo.forEach(f => {
			f.status = 'Uploaded';
			f.disp_status = 'Uploaded';
		});
		this.saveState();
	}

	removeFile(file: File) {
		this._uploadedFileInfo = this._uploadedFileInfo.filter(item =>
			!(item.file.name === file.name && item.file.size === file.size)
		);
	}

	// Table data for steps 4 and 5
	setStepTable(stepIdx: number, data: any[]) {
		if (stepIdx >= 0 && stepIdx < this._stepTables.length) {
			this._stepTables[stepIdx] = data;
			this.saveState();
		}
	}

	setSaveMessage(msg: string) {
		this._saveMessage = msg;
		this.saveState();
	}

	// Persistence
	saveState() {
		const state = {
			timelineStep: this._timelineStep,
			uploadedFileInfo: this._uploadedFileInfo.map(f => ({ ...f, file: undefined })),
			stepTables: this._stepTables,
			saveMessage: this._saveMessage
		};
		localStorage.setItem('indexInsertTimeline', JSON.stringify(state));
	}

	loadState() {
		const raw = localStorage.getItem('indexInsertTimeline');
		if (!raw) return;
		try {
			const state = JSON.parse(raw);
			this._timelineStep = state.timelineStep || 1;
			this._uploadedFileInfo = state.uploadedFileInfo || [];
			this._stepTables = state.stepTables || [[], []];
			this._saveMessage = state.saveMessage || '';
		} catch { }
	}

	private isXlsx(file: File): boolean {
		return file.name.toLowerCase().endsWith('.xlsx');
	}


	public createUploadStructure(files: File[]) {
		return {
			files: files,
			customerRecID: this.viewScopeService.getCurrentCustomer() ?? '',
			userId: this.viewScopeService.getCurrentOpertaingUserId().toString() ?? ''
		};
	}

	public getCalculatedSections(importNumber: number) {
		const customerRecID = localStorage.getItem('selectedCustomer') ? JSON.parse(localStorage.getItem('selectedCustomer')!).id : '';
		const userId = this.viewScopeService.getCurrentOpertaingUserId().toString() || '';
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + INDEX_SECTIONS_DEFINERS + customerRecID + '/' + importNumber + '/' + userId);
	}

	public getSectionOptions() {
		const customerRecID = localStorage.getItem('selectedCustomer') ? JSON.parse(localStorage.getItem('selectedCustomer')!).id : '';
		const userId = this.viewScopeService.getCurrentOpertaingUserId().toString() || '';
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + INDEX_SECTIONS_DEFINITIONS + customerRecID + '/' + userId);
	}

	public putSectionDefinitors(uploadRefNum: number, assignments?: { IndexSectionRecID: any, selectedSection?: any }[]) {
		// Build and return the required JSON structure
		const customerRecID = this.viewScopeService.getCurrentCustomer() ?? '';
		const userRecID = this.viewScopeService.getCurrentOpertaingUserId();
		let result;
		if (assignments) {
			const Sections = assignments.map(a => ({
				id: a.IndexSectionRecID,
				newId: a.selectedSection?.RecID ?? null
			}));
			result = { Sections, CustomerRecID: customerRecID, Import_ID: uploadRefNum, UserRecID: userRecID };
		} else {
			result = { Sections: [], CustomerRecID: customerRecID, Import_ID: uploadRefNum, UserRecID: userRecID };
		}
		const outObj = JSON.stringify(result);

		console.warn("!!!!");
		console.log(outObj);

		const api = this.ajaxService.getBaseOfApi() + INDEX_SECTIONS_SUBMIT;
		// Return the observable so the component can subscribe and handle loading/result
		return this.ajaxService.updateObjectData(api, outObj);
	}


}